<script>
import ArlAPI from "@/services/arl/arlAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import UserSSOAPI from "@/services/sso/users/userSSOAPI";
import UserAPI from "@/services/user/userAPI";
import CompanyAPI from "@/services/company/companyAPI";
import BranchAPI from "@/services/branch_offices/branch_officesAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import { required, email } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
export default {
  data() {
    return {
      submitted: false,

      showNotification: false,
      message: "",

      company_id: this.$route.params.id,
      nit: this.$store.getters["company/getCompany"].nit || null,

      companyData: {
        nit: "",
        dv: 0,
        type: null,
        uuid: null,
        sso_id: null,
        risk_level: "group_1",
        ciu_id: null,
        arl_id: null,
        ciius: [],
        id_diseno_sso: null,
        arl_certificate: "",
        company_classification_id: 5,
        legal_representative: null,
        legal_representative_email: null,
      },

      arls: [],
      cius: [],

      usersList: [],

      file: null,

      user: this.$store.state.auth,
      dataVisible: false,

      exist: false,

      loading2: true,
      loading4: true,

      role: this.$store.state.auth.info.role,
      branchOffices: [],
    };
  },
  validations: {
    companyData: {
      id_diseno_sso: {
        required,
      },
      arl_id: {
        required,
      },
      arl_certificate: {
        required,
      }
    },
  },
  methods: {
    getFile(file) {
      try {
        const name = file.split("/");
        return name[name.length - 1];
      } catch (error) {
        return file;
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.companyData.arl_certificate)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/Gestión_Empresas/${name}`;
        } else {
          url = `sst-prod/${this.nit}/Gestión_Empresas/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.companyData.arl_certificate = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * This method is used to go back to the previous page.
     */
    goBack() {
      this.$router.push("/forms/listado-empresa");
    },

    goBranch() {
      if (this.exist) {
        window.location.href = `/forms/${this.companyData.id}/listado-sedes`;
      } else {
        Swal.fire({
          title: "¡Alerta!",
          text: "¡Es necesario que se registre la información de la empresa!",
          type: "warning",
          icon: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
      }
    },

    getBranchOffices(id) {
      BranchAPI.getNotPaginate(id)
        .then((response) => {
          this.branchOffices = response.branch;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method allows to get users from SSO API that are type 'ADMIN' and 'WEB',
     * to be used in the select input.
     */
    getUsers() {
      try {
        UserSSOAPI.getAllAdmin()
          .then((response) => {
            const users = response.data;
            this.role = this.$store.state.auth.info.role
            if (users.length > 0) {
              UserAPI.getDesign()
                .then((response) => {
                  const sst = response.User_sst;
                  let designUsers = users.filter((user) =>
                    sst.find((us) => us.idsso === user.id)
                  );
                  this.usersList = designUsers;
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * This method is used to get the Company Data from SSO API with their id.
     */
    getCompany() {
      this.dataVisible = this.user.user.nodexum.roles.find(
        (role) => role.name === "root" || role.name === "admin",
      );

      CompanyAPI.getCompanyByUUID(this.$route.params.id)
        .then((response) => {
          let company = response[0] || null;
          let sstData = company || {
            personType: null,
            uuid: null,
            arl_id: null,
            arl_certificate: "",
            company_classification_id: 5,
            risk_level: "group_1",
            legal_representative: null,
            legal_representative_email: null,
            id_diseno_sso: null,
          };
          this.exist = response.length !== 0 ? true : false;
          if (this.exist) {
            this.getBranchOffices(sstData.id);
          }
          CompanySSOAPI.getCompany(this.$route.params.id)
            .then((response) => {
              let ssoData = response && typeof response === "object" ? response : {};
              // social_reason real viene del SSO; el del SST (columna nueva)
              // puede ser null y no debe pisarlo.
              this.companyData = { ...ssoData, ...sstData, social_reason: sstData.social_reason || ssoData.social_reason };
              this.companyData.type = this.companyData.is_natural == 0 ? 0 : 1;
              // El SSO puede no devolver datos (p.ej. 403 si el usuario no tiene
              // privilegios sobre la empresa): degradar sin romper la pantalla.
              const owners = Array.isArray(this.companyData.owners)
                ? this.companyData.owners
                : [];
              const user = owners.find(
                (owner) =>
                  Array.isArray(owner.roles) &&
                  owner.roles.find((role) => role.name === "company")
              );
              this.companyData.legal_representative =
                this.companyData.legal_representative != null
                  ? this.companyData.legal_representative
                  : user
                  ? user.name
                  : null;
              this.companyData.legal_representative_email = user
                ? user.email
                : this.companyData.legal_representative_email || null;
              this.loading2 = false;
            })
            .catch((error) => {
              console.log(error);
              this.loading2 = false;
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to get the ARLs from ARL API to be used in the select input.
     */
    getArl() {
      ArlAPI.getAllARLs()
        .then((response) => {
          this.arls = response.arl || [];
          this.loading4 = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading4 = false;
        });
    },

    /**
     * This method is used to create or update the Company Data in SST API.
     * To know if the company is new or already exists, the method getCompany() is used
     * and with the exist variable, the method is used to create or update the company.
     */
    async save() {
      try {
        this.submitted = true;
        this.loading2 = true
        const result = await this.uploadDocument()
        if (result) {
          let data = {
            id: this.companyData.id,
            uuid: this.$route.params.id,
            arl_id: this.companyData.arl_id,
            legal_representative: this.companyData.legal_representative,
            legal_representative_email: this.companyData.legal_representative_email,
            company_classification_id: 5,
            risk_level: this.companyData.risk_level,
            id_diseno_sso: this.companyData.id_diseno_sso,
            arl_certificate: this.companyData.arl_certificate,
          };
          if (this.exist) {
            CompanyAPI.updateCompany(data)
              .then((response) => {
                if (response.result === "Updated") {
                  const user = JSON.parse(localStorage.getItem('user'))
                  const dataScores = {
                    access_token: user.token,
                    companies_id: this.company_id
                  }
                  newScoresAPI.classificationCompanie(dataScores).then((response) => {
                    this.loading2 = false
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "La empresa ha sido actualizada con exito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }).catch((error) => {
                    console.log(error);
                    Swal.fire({
                      title: "¡Error!",
                      text: "La empresa no ha podido ser clasificada",
                      type: "warning",
                      icon: "warning",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  });
                } else {
                  Swal.fire({
                    text: "¡Error!",
                    title: "La empresa no ha podido ser actualizada",
                    type: "warning",
                    icon: "warning",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }
              })
              .catch((error) => {
                console.log(error);
                Swal.fire({
                  title: "¡Error!",
                  text: "La empresa no ha podido ser actualizada",
                  type: "warning",
                  icon: "warning",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              });
          } else {
            CompanyAPI.createCompany(data)
              .then((response) => {
                if (response[0] === "Data_created") {
                  const user = JSON.parse(localStorage.getItem('user'))
                  const dataScores = {
                    access_token: user.token,
                    companies_id: this.company_id
                  }
                  newScoresAPI.classificationCompanie(dataScores).then((response) => {
                    this.loading2 = false
                    Swal.fire({
                      title: "¡Éxito!",
                      text: "¡Empresa ha sido creada con exito!",
                      type: "success",
                      icon: "success",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  }).catch((error) => {
                    console.log(error);
                    Swal.fire({
                      title: "¡Error!",
                      text: "La empresa no ha podido ser clasificada",
                      type: "warning",
                      icon: "warning",
                      confirmButtonClass: "btn btn-confirm mt-2",
                    });
                    window.location.reload();
                  });
                } else {
                  Swal.fire({
                    title: "¡Error!",
                    text: "La empresa no ha podido ser creada",
                    type: "warning",
                    icon: "warning",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }
              })
              .catch((error) => {
                console.log(error);
                Swal.fire({
                  title: "¡Error!",
                  text: "La empresa no ha podido ser creada",
                  type: "warning",
                  icon: "warning",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              });
          }
        } else {
          this.loading2 = false
          setTimeout(() => {
            Swal.fire({
              title: "¡Error!",
              text: "¡No se ha podido actualizar!",
              type: "warning",
              icon: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            window.location.reload()
          }, 2000)
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getCompany();
    this.getArl();
    this.getUsers();
  },
};
</script>

<template>
  <form text-center class="form-horizontal form-group" role="form" @submit.prevent="save">
    <div v-if="!loading2">
      <b-container style="padding: 0% 20% 0% 20%">
        <b-col>
          <b-form-group label="Tipo de persona" label-for="personType">
            <b-form-select class="form-control" v-model="companyData.type" disabled>
              <b-form-select-option :value="1"> Persona Natural </b-form-select-option>
              <b-form-select-option :value="0"> Persona Jurídica </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="NIT" label-for="nit">
            <b-form inline>
              <b-form-input id="nit" type="text" placeholder="NIT" class="col-md-10" style="max-width: 78%"
                v-model="companyData.nit" disabled></b-form-input>
              <span class="mr-1"></span>
              <b-form-input id="dv" type="text" placeholder="DV" class="col-md-2 col-sm-1" style="max-width: 20%"
                v-model="companyData.dv" disabled>
              </b-form-input>
            </b-form>
          </b-form-group>

          <b-form-group id="socialReason" label="Nombre" label-for="socialReason">
            <b-form-textarea id="socialReason" rows="1" v-model="companyData.social_reason" disabled>
            </b-form-textarea>
          </b-form-group>

          <b-form-group label="Teléfono" label-for="phone">
            <b-form-input id="phone" maxlength="10" type="text" placeholder="Teléfono" v-model="companyData.phone"
              disabled>
            </b-form-input>
          </b-form-group>

          <b-form-group label="Representante legal" label-for="legalRepresentative">
            <b-form-input id="legalRepresentative" type="text" placeholder="Representante legal"
              v-model="companyData.legal_representative"></b-form-input>
          </b-form-group>

          <b-form-group label="Correo electrónico" label-for="email">
            <b-form-input required id="email" placeholder="Correo electrónico"
              v-model="companyData.legal_representative_email" disabled>
            </b-form-input>
          </b-form-group>

          <b-form-group id="ciiu" label="CIIU" label-for="ciiu">
            <b-form-select :select-size="3" disabled>
              <b-form-select-option v-bind:key="option.id" v-for="option in companyData.ciius" :value="option.id"
                :title="`${option.code} - ${option.name}`" v-b-tooltip.rightbottom>
                {{ option.code }} -
                {{ option.name }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Nivel de riesgo" label-for="risk_level">
            <select id="risk_level" required class="form-control" v-model="companyData.risk_level">
              <option value="group_1">Nivel I</option>
              <option value="group_2">Nivel II</option>
              <option value="group_3">Nivel III</option>
              <option value="group_4">Nivel IV</option>
              <option value="group_5">Nivel V</option>
            </select>
          </b-form-group>

          <b-form-group id="branchOffices" label="Sedes" label-for="sedes">
            <b-form-select :select-size="3" disabled>
              <b-form-select-option v-bind:key="item.id" v-for="item in branchOffices" :value="item.id"
                :title="item.name">
                {{ item.name }}
              </b-form-select-option>
            </b-form-select>
            <div class="col-12 text-right pt-1 mr-0">
              <button type="button" class="btn btn-primary" @click="goBranch">
                Agregar
              </button>
            </div>
          </b-form-group>
          <div v-if="this.role == 1 || this.role == 2 || this.role == 3">
            <b-form-group label="Responsable de diseño de SST" label-for="designResponsible">
              <b-form-select :class="{ 'is-invalid': submitted && $v.companyData.id_diseno_sso.$error }"
                class="form-control" v-model="companyData.id_diseno_sso"
                :disabled="user.info.role !== 1 && user.info.role !== 3">
                <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                  {{ item.name }}
                </b-form-select-option>
              </b-form-select>
              <div v-if="submitted && !$v.companyData.id_diseno_sso.required" class="invalid-feedback">
                Este campo es requerido.
              </div>
            </b-form-group>
          </div>
          <div v-else>
            <b-form-group label-for="designResponsible">
              <b-form-select :class="{ 'is-invalid': submitted && $v.companyData.id_diseno_sso.$error }"
                class="form-control" hidden v-model="companyData.id_diseno_sso"
                :disabled="user.info.role !== 1 && user.info.role !== 3">
                <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                  {{ item.name }}
                </b-form-select-option>
              </b-form-select>
              <div v-if="submitted && !$v.companyData.id_diseno_sso.required" class="invalid-feedback">
                Este campo es requerido.
              </div>
            </b-form-group>
          </div>
          <b-form-group label="ARL" label-for="arl">
            <b-form-select :class="{ 'is-invalid': submitted && $v.companyData.arl_id.$error }"
              v-model="companyData.arl_id" class="form-control">
              <b-form-select-option v-for="item in arls" :value="item.id" :key="item.id">
                {{ item.name }}
              </b-form-select-option>
            </b-form-select>
            <div v-if="submitted && !$v.companyData.arl_id.required" class="invalid-feedback">
              Este campo es requerido.
            </div>

            <b-form-file :class="{
              'is-invalid': submitted && $v.companyData.arl_certificate.$error,
            }" type="file" id="file" ref="file" name="file" class="mt-1" browse-text="Buscar"
              :placeholder="companyData.arl_certificate ? getFile(companyData.arl_certificate) : `Selecciona un archivo...`"
              drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
              accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
            </b-form-file>
            <div v-if="submitted && !$v.companyData.arl_certificate.required" class="invalid-feedback">
              Debe subir ARL
            </div>
          </b-form-group>

        </b-col>
      </b-container>

      <hr />

      <div class="form-group text-right m-b-0">
        <button :disabled="submitted" class="btn btn-primary" type="submit">Guardar</button>
        <button type="reset" class="btn btn-secondary m-l-5 ml-1" @click="goBack">
          Cancelar
        </button>
        <b-toast :visible="showNotification">
          <div slot="toast-title">
            <strong class="mr-auto"> Advertencia </strong>
          </div>
          <div>
            {{ message }}
          </div>
        </b-toast>
      </div>
    </div>
    <div v-else>
      <div class="text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </div>
  </form>
</template>
